module.exports = __webpack_public_path__ + "img/07_full.cb7e01f6.jpg";